// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 10903-闸机新增 新增闸机 POST /web/v1/gate/add */
export async function addGate(
  body: API.GateAddReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOLong>('/web/v1/gate/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 10905-闸机删除 删除闸机 GET /web/v1/gate/delete/${param0} */
export async function deleteGate(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGateParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/gate/delete/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 10902-闸机详情查询 根据ID查询闸机详情 GET /web/v1/gate/detail/${param0} */
export async function getGateDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGateDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymGateDetailVo>(
    `/web/v1/gate/detail/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 10901-闸机列表查询 查询闸机列表 GET /web/v1/gate/list */
export async function getGateList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGateListParams,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOListSwimGymGateListVo>('/web/v1/gate/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 10907-闸机开门记录查询 分页查询闸机开门记录 POST /web/v1/gate/openRecordList */
export async function getGateOpenActionList(
  body: API.GateOpenActionListReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimGymGateOpenActionListVo>(
    '/web/v1/gate/openRecordList',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 10907-分页查询闸机列表 POST /web/v1/gate/pageList */
export async function webGetSwimGatePageList(
  body: API.SwimGatePageQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimGymGateListVo>(
    '/web/v1/gate/pageList',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 10904-闸机修改 修改闸机信息 POST /web/v1/gate/update */
export async function updateGate(
  body: API.GateUpdateReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/gate/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 10906-闸机状态变更 变更闸机状态 POST /web/v1/gate/updateStatus */
export async function updateGateStatus(
  body: API.GateStatusUpdateReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/gate/updateStatus', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
